import * as React from 'react';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepButton from '@mui/material/StepButton';

export default function DomainsStepper({
  activeStep,
  children,
}: {
  activeStep: number;
  children: React.ReactNode[];
}) {
  const steps = ['Enter domain', 'Configure DNS', `You're done!`];
  return (
    <Box sx={{ width: '100%' }}>
      <Stepper nonLinear activeStep={activeStep}>
        {steps.map((label, index) => (
          <Step key={label} completed={index < activeStep || activeStep === 2}>
            <StepButton color="inherit">{label}</StepButton>
          </Step>
        ))}
      </Stepper>
      <div className="mb-10" />
      <Box>{children[activeStep]}</Box>
    </Box>
  );
}
